export const SCENE_QUERY_KEYS = {
  adaptedFictionEditionComments: (adaptedFictionEditionId: string) =>
    ['adaptedFictionEditionComments', adaptedFictionEditionId] as const,

  adaptedFictionEditionReplies: (adaptedFictionEditionId: string, commentId: string) =>
    ['adaptedFictionEditionReplies', adaptedFictionEditionId, commentId] as const,

  sceneCommentDetail: (adaptedFictionEditionId: string, commentId: string) =>
    ['sceneCommentDetail', adaptedFictionEditionId, commentId] as const
};

